import { ModuleSchema } from '../module/ModuleSchemaTypes';
import { ParamSchema, ParamSchemaTypes } from '../params/ParamSchemaTypes';

const tmpnameSchema: ParamSchema = {
  type: ParamSchemaTypes.STRING,
  param: 'state',
  displayName: 'Label',
  optional: false,
};

const questionSchema: ParamSchema = {
  type: ParamSchemaTypes.STRING,
  param: 'question',
  displayName: 'Question',
  description:
    'A question for the chatbot to ask the user, pausing the workflow until the chatbot receives a response.',
};

const retryHelpSchema: ParamSchema = {
  type: ParamSchemaTypes.STRING,
  param: 'retryHelpTxt',
  displayName: 'Retry help',
  description:
    "If the user returns something that the chatbot doesn't recognize, this custom retry help text appears with more options.",
};

const checkValueSchema: ParamSchema = {
  type: ParamSchemaTypes.STRING,
  allowArray: true,
  param: 'checkValue',
  displayName: 'Values To Check For',
  arrayItemsLabel: 'Value',
  description:
    "Specific information for the chatbot to look for in the user's response before resuming the workflow.",
};

const buildCtxToParse = (contexts: string[]): ParamSchema => ({
  type: ParamSchemaTypes.ENUM,
  param: 'ctxToParse',
  displayName: 'Context',
  description:
    "Context parameters for the chatbot to look for in the user's response before resuming the workflow.",
  value: contexts,
  allowArray: true,
});

const answerSchema: ParamSchema = {
  type: ParamSchemaTypes.STRING,
  param: 'answer',
  displayName: 'Answer',
  description:
    'The answer given to the user. Please note, if an answer is given the workflow stops at this point.',
};

const childConversationSchema: ParamSchema = {
  type: ParamSchemaTypes['BRIDGE.WORKFLOW'],
  value: [],
  param: 'childConversation',
  displayName: 'Workflow to trigger',
  description: 'The name of the workflow to trigger.',
};

const childIteratorSchema: ParamSchema = {
  type: ParamSchemaTypes.STRING,
  param: 'childIterator',
  displayName: 'Number of runs',
  description:
    'Enter a number or reference an array of data to specify how many times the child workflow should run. If left empty, the child will run once.',
};

const childInputSchema: ParamSchema = {
  type: ParamSchemaTypes.MAP,
  param: 'childInput',
  displayName: 'Child entity values',
  description: 'A map of entity keys and values to set on the workflow.',
};

export const buildStateSchema = (): ParamSchema[] => [tmpnameSchema];

export const buildJunctionSchema = (): ParamSchema[] => [
  tmpnameSchema,
  questionSchema,
  retryHelpSchema,
];

export const buildJunctionChildSchema = (contexts: string[]): ParamSchema[] => [
  tmpnameSchema,
  checkValueSchema,
  buildCtxToParse(contexts),
  answerSchema,
];

export const buildChildWorkflowSchema = (): ParamSchema[] => [
  tmpnameSchema,
  childConversationSchema,
  childIteratorSchema,
  childInputSchema,
];

export const buildGroupSchema = (moduleSchema: ModuleSchema): ModuleSchema => ({
  ...moduleSchema,
  params: [
    {
      type: 'PARAM',
      param: 'moduleData',
      valueParams: moduleSchema.params,
    },
  ],
});
